/**
 * 封装sessionStorage
 * 增加对JSON对象的转换
 * @return {[type]} [description]
 */
const sessionDb = {
  /**
   * 按key存贮数据value到sessionStorage
   * @param {String} key   存贮数据的唯一标识
   * @param {String, Object} value 所要存贮的数据
   */
  set(key, value) {
    if (!value) delete window.sessionStorage[key];
    else {
      const val = typeof value === "object" ? JSON.stringify(value) : value;
      window.sessionStorage[key] = val;
    }
  },

  /**
   * 通过key从sessionStorage获取数据
   * @param  {String} key  获取数据的可以标识
   * @return {String, Object}  返回空，字符串或者对象
   */
  get(key) {
    const str = window.sessionStorage[key] || "";
    return this.isJSONStr(str) ? JSON.parse(str) : str;
  },

  /**
   * 判断是否是JSON string
   * @param  {String}  str 所要验证的字符串
   * @return {Boolean}   是否是JSON字符串
   */
  isJSONStr(str) {
    return (
      (str.charAt(0) === "{" && str.charAt(str.length - 1) === "}") ||
      (str.charAt(0) === "[" && str.charAt(str.length - 1) === "]")
    );
  },

  /**
   * 清空sessionStorage
   * @return 无返回NULL
   */
  clear() {
    window.sessionStorage.clear();
  },
};

export default sessionDb;



// WEBPACK FOOTER //
// ./src/util/sessionDb.js